import { performRequest } from "./api-handler";
import { URLS } from "../utility/urls";

export default () => {
  const {
    GET_TOP_MODULES_DETAILS,
    ADD_TOP_MODULES_DETAILS,
    UPDATE_TOP_MODULES_DETAILS,
    DELETE_TOP_MODULES_DETAILS,
  } = URLS;

  return {
    getTopModulesDetails: (body = {}, method = "get") =>
      performRequest(method ? method : "get", GET_TOP_MODULES_DETAILS, body),
    addTopModulesDetails: (body = {}, method = "post") =>
      performRequest(method ? method : "post", ADD_TOP_MODULES_DETAILS, body),
    updateTopModulesDetails: (body = {}, method = "put") =>
      performRequest(method ? method : "put", UPDATE_TOP_MODULES_DETAILS, body),
    deleteTopModulesDetails: (body = {}, method = "delete") =>
      performRequest(method ? method : "delete", DELETE_TOP_MODULES_DETAILS, body),
  };
};

